<template>
    <div>
        <div class="row">
            <div class="col-lg-12">
                <fieldset v-if="isDataLoaded()" :disabled="carregando">
                    <Quadro :type="messageType" :message="message" />
                    <form class="text-left">
                        <div class="d-print-none">
                            <a
                                id="btn_voltar"
                                class="btn btn-secondary mr-1"
                                data-toggle="modal"
                                data-target="#modalInsumo"
                            >
                                <i class="fa fa-arrow-left"></i> Voltar</a
                            >
                            <button type="button" id="btnSave" class="btn btn-primary mr-1" @click="salvar">
                                Salvar
                            </button>

                            <hr />
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <fieldset>
                                    <div class="form-row">
                                        <InputAndLabel
                                            column="3"
                                            name="id"
                                            label="ID"
                                            type="text"
                                            v-model="dados[idname].value"
                                            readonly
                                        />
                                        <SelectAndLabel
                                            column="9"
                                            name="idinsumo"
                                            label="Insumo"
                                            :options="combos.insumo"
                                            v-model="dados.idinsumo.value"
                                            :errorMessage="errors.idinsumo"
                                        />
                                    </div>
                                    <div class="form-row">
                                        <InputAndLabel
                                            column="6"
                                            name="qtde"
                                            label="Qtde."
                                            type="number"
                                            v-model="dados.qtde.value"
                                            :errorMessage="errors.qtde"
                                            right
                                        />
                                        <InputAndLabel
                                            column="6"
                                            name="valor"
                                            label="Valor"
                                            type="number"
                                            v-model="dados.valor.value"
                                            :errorMessage="errors.valor"
                                            right
                                        />
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                    </form>
                </fieldset>
            </div>
        </div>
    </div>
</template>

<script>
import api from "../services/api";
import InputAndLabel from "@/components/InputAndLabel";
import SelectAndLabel from "@/components/SelectAndLabel";
import Quadro from "@/components/Quadro";
import ViewMixin from "./ViewMixin";

import {
    ClientErrorException,
    DEFAULT_ERROR_MESSAGE,
    PermissaoException,
    ServerErrorException,
    TokenInvalidoException,
    ValidationException,
} from "../services/exceptions";

export default {
    name: "CobrancaInsumo",
    mixins: [ViewMixin],
    components: {
        InputAndLabel,
        SelectAndLabel,
        Quadro,
    },
    props: ["id", "idparent", "parentBaseUrl", "parentGetData", 'parentsetInsumoSelecionado'],
    data: function() {
        return {
            idname: "idcobranca_insumos",
            baseUrl: "insumo",
            title: {
                icon: "fas fa-pallet",
                text: "Insumo",
            },
            combos: {
                idcliente: [],
            },
            // dados: {
            //   documento: ''
            // },
            mensagem: "",
        };
    },
    mounted() {
        this.defineOperation(this.id);
        this.getCombo().then(this.getData);
    },
    methods: {
        async getCombo() {
            this.carregando = true;

            try {
                let response = await api.get(`/${this.parentBaseUrl}/${this.idparent}/${this.baseUrl}/combosToSave`);
                let data = response.data;
                this.combos = data;
            } catch (e) {
                if (e instanceof ValidationException) {
                    this.handleValidationException(e);
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    this.setMessage(e.message, "danger");
                } else {
                    this.setMessage(DEFAULT_ERROR_MESSAGE, "danger");
                }
            }

            this.carregando = false;
        },
        async getData(id = this.id) {
            this.carregando = true;

            try {
                let response = await api.get(`/${this.parentBaseUrl}/${this.idparent}/${this.baseUrl}/${id}`);
                let data = response.data;
                this.setData(data, ["movs"]);
            } catch (e) {
                if (e instanceof ValidationException) {
                    this.handleValidationException(e);
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    this.setMessage(e.message, "danger");
                } else {
                    this.setMessage(DEFAULT_ERROR_MESSAGE, "danger");
                }
            }

            this.carregando = false;
        },
        async salvar() {
            this.carregando = true;

            try {
                let response;
                let id = this.dados[this.idname].value;
                let newData;
                let fieldsToDelete = ["movs"];
                if (this.operation === "update") {
                    newData = this.getDataToUpdate(fieldsToDelete);
                    newData['idcobranca'] = this.idparent
                    response = await api.put(`/${this.parentBaseUrl}/${this.idparent}/${this.baseUrl}/${id}`, newData);
                } else {
                    newData = this.getDataToInsert(fieldsToDelete);
                    newData['idcobranca'] = this.idparent
                    response = await api.post(`/${this.parentBaseUrl}/${this.idparent}/${this.baseUrl}`, newData);
                }
                let data = response.data;
                id = data.id;
                this.dados[this.idname] = { value: id, oldValue: id };
                this.operation = "update";

                this.updateData(newData);

                this.parentGetData(this.idparent);
                this.parentsetInsumoSelecionado(id);

                setTimeout(() => {
                    this.setMessage(data.successMessage, "success");
                    this.errors = {};
                }, 100);
            } catch (e) {
                if (e instanceof ValidationException) {
                    this.handleValidationException(e);
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    this.setMessage(e.message, "danger");
                } else {
                    this.setMessage(DEFAULT_ERROR_MESSAGE, "danger");
                }
                console.error(e);
            }

            this.carregando = false;
        },
    },

    watch: {
        "id": {
            handler: function(newVal, oldVal) {

                console.log(newVal);
                console.log(oldVal);
                this.defineOperation(this.id);
                this.getData();
                this.setMessage('')
            },
        },
    },
};
</script>

<style>
/* css */
</style>
